import styled from "styled-components";
import { fadeIn } from "../../../components/Common/CommonStyles";

export const LoginLayoutBody = styled.div`
  background-image: ${(props) =>
    props.fondoEmpresa
      ? 'url("' + props.fondoEmpresa + '")'
      : 'url("./images/loginBG.jpg")'};
  background-position: bottom;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-color: #fff;
  overflow: hidden;
  animation: ${fadeIn} 0.2s ease-in;
  @media (max-height: 768px) {
    background-position: ${(props) => props?.isPrimera ? "bottom" : "top"};
    background-size: ${(props) => props?.isPrimera ? "cover" : "contain"};
  }

  @media (min-width: 1900px) {
    background-size: ${(props) => props?.isPrimera ? "cover" : "contain"};
  }

  @media (min-height: 1080px) {
    background-size: ${(props) => props?.isPrimera ? "cover" : "contain"};
  }

`;

export const LoginLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 20px;
  overflow: hidden;
  height: ${(props) => props?.height || "100vh"};
  @media (max-height: 800px) {
    height: ${(props) => props?.isPrimera ? "75vh" : "85vh"};
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const LoginContainer = styled.div`
  width: 300px;
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-right: ${(props) => props?.marginRight || ""};
  @media (max-width: 844px) {
    margin-right: auto;
    animation: ${fadeIn} 0.5s ease-in;
  }

  @media (max-width: 320px) {
    width: 200px;
  }
`;

export const FormLogin = styled.form`
  display: flex;
  flex-direction: column;
`;

export const LogoUnoContainer = styled.footer`
  padding: 18px;
  position: ${(props) => props?.footerPosition || "fixed"};
  bottom: 0;
  right: 0;
  margin-right: ${(props) => props?.marginRight || "auto"};
  margin-right: 250px;
  @media (max-width: 844px) {
    margin-right: auto;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const UnoPrimera = styled.img`
  src: ${(props) => props?.src || "fixed"};
  alt: Uno;
  width: 100px;
  height: 300px;
  @media (max-height: 700px) {
    height: 200px;
  }

  @media (max-height: 600px) {
    height: 100px;
  }

  @media (max-height: 500px) {
    display: none;
  }

`;

export const LoginStyles = {
  inputLoginWidth: "283px",
  inputLoginHeight: "25px",
  buttonLoginWidth: "305px",
};